<div class="col-md-12 d-flex justify-content-center mt-3" >
    <div class="col-md-12 row " >
        <div class=" col-md-12 ">
           <form    class=" row" >
            <mat-form-field class="col-md-6 form-group ">
                    
              <mat-select  matNativeControl name="page"  >
                <mat-option  value="default" >Default</mat-option>
                <mat-option  value="staff" >Login Page</mat-option>
                <mat-option  value="agent" >Menu Page</mat-option>
              </mat-select>
              </mat-form-field>

                    <mat-form-field class="col-md-6 form-group ">
                      <mat-label>Catogery</mat-label>
                        <mat-select matNativeControl name="catogery"    >
                          <mat-option  value="primary">Primary</mat-option>
                            <mat-option  value="topBar">Top Bar</mat-option>
                            <mat-option  value="footerBar">Footer Bar</mat-option>
                            <mat-option  value="Sbutton">Save Button</mat-option>
                            <mat-option  value="Sbutton">Close Button</mat-option>
                            <mat-option  value="Bar">Login Button</mat-option>


                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-md-6 form-group ">
                      <mat-label>Text Color</mat-label>
                       <input matNativeControl type="color">
                    </mat-form-field>
                    <mat-form-field class="col-md-6 form-group ">
                      <mat-label>background-color</mat-label>
                       <input matNativeControl type="color" [(ngModel)]="backgroundColorValue" [ngModelOptions]="{standalone: true}">
                    </mat-form-field>
                    <mat-form-field class="col-md-6 form-group ">
                      <mat-label>SideBar-color</mat-label>
                       <input matNativeControl type="color" [(ngModel)]="screen.sideBarColor" [ngModelOptions]="{standalone: true}">
                    </mat-form-field>
                    <mat-form-field class="col-md-6 form-group ">
                      <mat-label>Header-color</mat-label>
                       <input matNativeControl type="color" [(ngModel)]="screen.headerColor" [ngModelOptions]="{standalone: true}">
                    </mat-form-field>
                    <button (click)="colorChange()" class="btn">save</button>
              </form>

        </div>
        </div>
        </div>